import './CustomFileUploader.css'

const CustomFileUploaderLoader = ({
    sz
}) => {
    return (
        <div className={`relative flex items-center justify-center w-${sz} h-${sz} bg-gray-200 border border-input rounded-md mr-2 cursor-pointer mt-2 overflow-hidden`}>      
            <div className="customfileuploaderloader">
                <div className="block"></div>
                <div className="block"></div>
                <div className="block"></div>
                <div className="block"></div>
                <div className="block"></div>
                <div className="block"></div>
                <div className="block"></div>
                <div className="block"></div>
                <div className="block"></div>
                <div className="block"></div>
                <div className="block"></div>
                <div className="block"></div>
                <div className="block"></div>
                <div className="block"></div>
                <div className="block"></div>
                <div className="block"></div>
            </div>
        </div> 
    );
};

export default CustomFileUploaderLoader